import type { Job } from 'src/context/api/data/api';

// Brand Infringement per-domain exports report their own success and failure on
// the page, synchronously, with the backend's message. `/traffic/export/jobs` is
// not filtered by action, so they must be dropped here or the poller adds a
// second, contradictory toast up to 15s after the first.
const SELF_REPORTED_ACTIONS: Job['action'][] = ['bi:trademark-export'];

// Split raw export jobs into "active" (still in flight, rendered live in the
// export tab) and "failed" (never listed — surfaced only as an ephemeral toast).
export function splitExportJobs(jobs: Job[] = []): { active: Job[]; failed: Job[] } {
  const owned = jobs.filter((j) => !SELF_REPORTED_ACTIONS.includes(j.action));
  const active = owned.filter((j) => ['running', 'pending', 'created'].includes(j.status));
  const failed = owned.filter((j) => j.status === 'failed');
  return { active, failed };
}

// Download URL of a completed export job. The job id comes from the
// notification's structured `job_id` field — never from its message text.
export function exportDownloadUrl(jobId: string): string {
  return `${process.env.CROSS_API_URL}/traffic/export/${jobId}/download`;
}
